import { createApp } from 'vue';
import { createPinia } from 'pinia';
import PrimeVue from 'primevue/config';

import App from '@/App.vue';
import { router } from '@/router';
import { i18n } from '@/locales';

// PrimeVue 3 theme + base styles (NOT v4 — Figma is built on v3 classes).
// Import order matters: PrimeVue theme → PrimeVue core → our tokens (override
// PV's CSS vars) → our base reset → PrimeIcons.
import 'primevue/resources/themes/aura-light-blue/theme.css';
import 'primevue/resources/primevue.min.css';
import '@/styles/tokens.css';
import '@/styles/base.css';
import 'primeicons/primeicons.css';

const app = createApp(App);

app.use(createPinia());
app.use(router);
app.use(i18n);
app.use(PrimeVue, {
  ripple: true,
  // Align PrimeVue's auto z-index bases with our token layers (tokens.css):
  // floating form action bars sit at --qb-z-overlay (2000), so PrimeVue's
  // default modal base (1100) left an open Dialog's mask BELOW the action bar —
  // the page's Cancel/Save stayed bright and clickable over the dimmed modal.
  // modal → --qb-z-dialog (3000) so the mask covers the action bar; overlay/menu
  // → 2100 so page dropdowns/menus also clear the action bar. Overlays opened
  // INSIDE a dialog still stack above it via PrimeVue's auto-increment.
  zIndex: {
    modal: 3000,
    overlay: 2100,
    menu: 2100,
    tooltip: 3100,
  },
});
// Calendar month/day names + button labels follow the app locale — applied (and
// kept in sync) by App.vue, which merges our tables onto PrimeVue's defaults.

app.mount('#app');
